export const enum ResumeParserStatus {
  UNINITIALIZED,
  PENDING,
  FINISHED,
}
